import { canv } from "@/canv/global";
import { getContrastColor } from "@/canv/utils";
import { STICKER_COLORS } from "@/elements/sticker";
import type { widgetOption } from "@/widgetMenu/widgetMenu";
import { wmBase } from "@/widgetMenu/wmBase";

type OptionsList = widgetOption<string>[];

export class WmStickerColor extends wmBase {
    constructor(options: OptionsList) {
        super();
        this.options = options;
    }

    build() {
        const uniqValues = Array.from(new Set(this.options.map((opt) => opt.value))) as Array<
            OptionsList[0]["value"]
        >;

        const mainColor = uniqValues[0] ?? "white";
        const adderColor = uniqValues[1] ?? mainColor;

        this.mainColor = mainColor;
        this.addedColor = adderColor;

        return `
            <div class="wm_stickerColor">
                <div class="wm_stickerColor_inner" style="background-color: ${mainColor}">
                    <div class="wm_stickerColor_inner_add" style="background-color: ${adderColor}"></div>
                </div>
            </div>
        `;
    }

    init() {
        const item = document.querySelector(".wm_stickerColor");
        item?.removeEventListener("click", this.toggleSubMenu, false);
        item?.addEventListener("click", this.toggleSubMenu, false);
    }

    toggleSubMenu = (e) => {
        const subm = document.querySelector(".wm_stickerColor_submenu");
        if (subm) {
            subm.outerHTML = "";
            return;
        }
        const otherSubm = document.querySelector(".widgetSubMenu");
        if (otherSubm) {
            otherSubm.outerHTML = "";
        }

        canv.widgetMenu.subMenuBoss = "wm_stickerColor";
        const submenu = document.createElement("div");
        submenu.classList.add("widgetSubMenu");
        submenu.classList.add("wm_stickerColor_submenu");
        submenu.style.opacity = "0";

        STICKER_COLORS.forEach((color) => {
            const item = document.createElement("button");
            item.setAttribute("type", "button");
            item.classList.add("wm_stickerColor_submenu_item");
            if (color === this.mainColor || color === this.addedColor) {
                item.classList.add("wm_stickerColor_submenu_item_active");
            }
            const contrastColor = getContrastColor(color);
            item.setAttribute("data-color", color);
            item.setAttribute("data-contrast-color", contrastColor);
            const inner = document.createElement("div");
            inner.style.setProperty("--color", color);
            inner.style.setProperty("--contrast-color", contrastColor);
            inner.innerHTML = `
            <svg fill="none" height="12" viewBox="0 0 12 12" width="12" xmlns="http://www.w3.org/2000/svg">
                <path d="m10.5 2.90625-6.1875 6.1875-2.8125-2.8125" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                    stroke-width="1.5" />
            </svg>
            `;
            item.appendChild(inner);
            item.addEventListener("click", this.handleSetColor);

            submenu.appendChild(item);
        });

        document.body.prepend(submenu);

        setTimeout(canv.widgetMenu.TryLocateMenu.bind(canv.widgetMenu), 50);
    };

    handleSetColor = (e: PointerEvent) => {
        const target = e.currentTarget;
        if (!(target instanceof HTMLButtonElement)) {
            return;
        }
        const newColor = target.getAttribute("data-color");
        if (!newColor) {
            return;
        }
        this.applyValue(this.options, newColor);
        this.mainColor = newColor;
        this.addedColor = newColor;

        // update widget menu color
        const menuItem = document.querySelector(".wm_stickerColor");
        if (menuItem) {
            const inner = menuItem.querySelector("div");
            if (inner) {
                inner.style.backgroundColor = newColor;

                const innerAdd = inner.querySelector("div");
                if (innerAdd) {
                    innerAdd.style.backgroundColor = newColor;
                }
            }
        }

        // update active item
        const items = document.querySelectorAll(".wm_stickerColor_submenu_item");
        items.forEach((item) => {
            item.classList.remove("wm_stickerColor_submenu_item_active");
        });
        target.classList.add("wm_stickerColor_submenu_item_active");
    };

    name = "wm_stickerColor";
    options: OptionsList = [];
    mainColor?: string;
    addedColor?: string;
}
